import Templates from '../../../base/pages/templates';

const templates: Templates = {
  selectTemplate: 'Vyberte šablonu',
  update: 'Aktualizovat'
};

export default templates;
